module.exports = __webpack_public_path__ + "img/کلاسیک.44fc2407.jpg";